import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link
      to={`/categories/${item?.slug || item?.slugPath}`}
      className="category-card-wrapper"
    >
      <div className="category-card">
        <div className="category-image-container">
          {item?.image && (
            <img src={item?.image} alt={item?.name} className="category-image" />
          )}
          <div className="category-overlay"></div>
        </div>
        <div className="category-title-box">
          <h3 className="category-title">{item.name}</h3>
          <span className="shop-now-text">Explore</span>
        </div>
      </div>
    </Link>
  );
}

export default Card;
